import Vue from 'vue'
import App from './App'
import resource from './resource'; //通过import引入
import VueLazyload from 'vue-lazyload';
import HTTP from './assets/js/http.js'; //全局公用http请求
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import BASE from './assets/js/global.js'; //全局公用方法
import filters from './filters/filters.js';
import Vant from 'vant';
import 'vant/lib/index.css';
import {
    Tab,
    Tabs,
    Sticky
} from 'vant'
Vue.use(Tab).use(Tabs);
Vue.use(Vant);
Vue.use(VueLazyload, {
    preload: 1.3, //预加载的宽高
    loading: 'https://i0.ulecdn.com/ulewap/i/290x290x2x.png',
    error: 'https://i0.ulecdn.com/ulewap/i/290x290x2x.png',
    attempt: 3, //尝试加载的次数
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'] //你想让vue监听的事件
});
Vue.use(HTTP);
Vue.use(MintUI);
Vue.use(BASE);

// 注册所有的filter
for (let key in filters) {
    Vue.filter(key, filters[key])
}
Vue.config.productionTip = false
new Vue({
    el: '#app',
    resource,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js